import {WellLabel} from 'contents/PlateTypeEditor/PlateTypeEditorEnum';
import * as actiontypes from '../../constants/actionType';
import {Orientation, PlateType, WellSurfaceDataShape} from '../../constants/dataEnum';

export const formatLabware = (lab) => ({
  LabwareID: lab.id,
  IDPrefix: lab.id.toString(),
  LabwareType: lab.type,
  rowCount: lab.rowCount,
  name: lab.description,
  colCount: lab.colCount,
  isWellRectangle: lab.wellSurfaceData.Shape === WellSurfaceDataShape.RECTANGLE,
  orientation: Orientation.LANDSCAPE,
  wellCapacity: lab.wellCapacity,
  workingCapacity: lab.workingCapacity,
  deadVolume: lab.deadVolume,
  recentlyAdded: false,
  isTrough: lab.rowCount === 1 || lab.colCount === 1,
  wellDepth: lab.wellBottomData.WellDepth,
  height: lab.height,
  hash: lab.hash,
  wellSurfaceData: lab.wellSurfaceData || {},
  isIFC: lab.type === PlateType.IFC.toLowerCase(),
  isSpearBio: lab.wellLabel === WellLabel.WELL_SPEAR_BIO,
  labwareLabel: lab.wellLabel,
});

export function setRecentLabware(labwareId) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_RECENT_LABWARE, labwareId});
  };
}

export function setInitialLabware(responseLabware) {
  return (dispatch) => {
    const labwareList = {};
    responseLabware.forEach((lab) => {
      if (lab) {
        let labware = formatLabware(lab);

        if (lab.parentInfo) {
          // collect IFC child labware
          const {parentId, index} = lab.parentInfo;
          const parentLabware = labwareList[parentId];
          if (parentLabware) {
            const labwareIndexes = parentLabware?.labwareIndexes ?? {};

            labware = {...labware, labwareIndex: index};

            labwareList[parentId].labwareIndexes = {
              ...labwareIndexes,
              [index]: labware,
            };
          }
        } else {
          let imagePath;
          let thumbnail;
          const spearBioCamelCase = PlateType.SPEAR_BIO.slice(0, 1).toLowerCase() + PlateType.SPEAR_BIO.slice(1);
          if (lab.type === PlateType.IFC.toLowerCase() || lab.type === spearBioCamelCase) {
            imagePath =
              `/svg/labwares/template-${lab.type}-${lab.rowCount}.${lab.colCount}-${lab.wellSurfaceData.Shape}.svg`.toLowerCase();
            thumbnail =
              `/svg/labwares/thumbnail-${lab.type}-${lab.rowCount}.${lab.colCount}-${lab.wellSurfaceData.Shape}.svg`.toLowerCase();
          } else {
            imagePath =
              `/svg/labwares/template-${lab.rowCount * lab.colCount}-${lab.wellSurfaceData.Shape}.svg`.toLowerCase();
            thumbnail =
              `/svg/labwares/thumbnail-${lab.rowCount * lab.colCount}-${lab.wellSurfaceData.Shape}.svg`.toLowerCase();
          }

          labware = {
            ...labware,
            image: imagePath,
            thumbnail,
            isSpearBio: lab.type === spearBioCamelCase,
          };

          labwareList[lab.id] = labware;
        }
      }
    });

    dispatch({type: actiontypes.ADD_INITIAL_LABWARE, labware: labwareList});
  };
}
